export default{
    familyHistory : 'Family History',
    pastMedicalHistory : 'Past Medical History',
    historyOfInfertilityInFamily: 'History Of Infertility',
    historyOfInfertilityInFamilyDescription: 'History Of Infertility In Family Description',
    specificDiseaseInFamilyMembers: 'Specific Disease In Family Members',
    specificDiseaseInFamilyMembersDescription: 'Specific Disease In Family Members Description',
    cancerInFamilyMembers: 'Cancer In Family Members',
    cancerInFamilyMembersDescription: 'Cancer In Family Members Description',
    typeOfDiseaseInFamilyMembers: 'Type Of Disease In Family Members',
    historyOfCancerInFamilyMembers: 'History Of Cancer In Family Members',
    historyOfDiseaseInFamilyMembers: 'history Of Disease In Family Members',
    historyOfDisease: 'History Of Disease',
    historyOfCancer: 'History Of Cancer',
    typeOfCancer: 'Type Of Cancer',
    surgicalHistory: 'Surgical History',
    typeOfSurgery: 'Type Of Surgery',
    surgery: 'Surgery',
    sonographyHistory: 'Sonography History',
    sonography: 'Sonography',
    clinicSonography: 'Clinic Sonography',
    sonographyOutSide : 'External Sonographies',
    sonographyType: 'Sonography Type',
    labType: 'Lab Type',
    type: 'Type',
    result: 'Result',
    radiologyHistory: 'Radiology History',
    papSmear: 'papSmear',
    mri: 'MRI',
    mriList: 'MRI List',
    list: 'List',
    ctScan: 'CT Scan',
    ctScanList: 'CT Scan List',
    date: 'date',
    medication: 'Medication',
    sfa: 'SFA',
    dfa: 'DFI',
}